module.exports = __webpack_public_path__ + "static/img/moreproduct3.703282de.png";